/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_DInputs */

const en_pol_scenario_d = /** @type {(inputs: Pol_Scenario_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep cloud · Bystep's key`)
};

const id_pol_scenario_d = /** @type {(inputs: Pol_Scenario_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud Bystep · kunci Bystep`)
};

/**
* | output |
* | --- |
* | "Bystep cloud · Bystep's key" |
*
* @param {Pol_Scenario_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_d = /** @type {((inputs?: Pol_Scenario_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_d(inputs)
	return en_pol_scenario_d(inputs)
});